import React from 'react';
import Quiz from './Quiz';

export default function App() {
  return (
    <div>
      <Quiz />
      </div>
  )
}